import React from 'react';
import { palette } from '../../constants';
import * as Elements from './Loader.styles';
export var sizes = {
    tiny: '8px',
    small: '20px',
    default: '24px'
};
export var width = {
    tiny: '32px',
    small: '88px',
    default: '100px'
};
export var Loader = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b, _c = _a.appearance, appearance = _c === void 0 ? 'overlay' : _c, overlayOpacity = _a.overlayOpacity, overlayBackground = _a.overlayBackground, _d = _a.color, color = _d === void 0 ? palette.neutral4 : _d;
    return (React.createElement(Elements.OuterWrapper, { appearance: appearance, overlayBackground: overlayBackground, overlayOpacity: overlayOpacity },
        React.createElement(Elements.Container, { size: size },
            React.createElement(Elements.Circle, { size: size, color: color }),
            React.createElement(Elements.Circle, { size: size, color: color }),
            React.createElement(Elements.Circle, { size: size, color: color }))));
};
//# sourceMappingURL=Loader.js.map